package uz.ferro.shop.model

enum class DocumentType {
    TEXT,
    RICH_TEXT,
    JSON,
    UNKNOWN
}
